import { Filter } from "@/common/model/Filter";
import { Nullable } from "@/general/custom-types/CustomTypes";

export class MeterFilter extends Filter {
  customer?: Nullable<number[]>;
  facility?: Nullable<number[]>;
  dataLogger?: Nullable<number[]>;
  deviceNumber?: Nullable<number>;

  constructor(
    customer?: Nullable<number[]>,
    facility?: Nullable<number[]>,
    dataLogger?: Nullable<number[]>,
    deviceNumber?: Nullable<number>
  ) {
    super("meter-filter");
    this.customer = customer;
    this.facility = facility;
    this.dataLogger = dataLogger;
    this.deviceNumber = deviceNumber;
  }

  clear(): void {}

  toQueryParam(): string {
    let query: string = "";
    if (this.customer && this.customer.length > 0) {
      query += `&customer=${this.customer}`;
    }
    if (this.facility && this.facility.length > 0) {
      query += `&facility=${this.facility}`;
    }
    if (this.dataLogger && this.dataLogger.length > 0) {
      query += `&dataLogger=${this.dataLogger}`;
    }

    if (this.deviceNumber) {
      query += `&deviceNumber=${this.deviceNumber}`;
    }
    return query;
  }
}
